export type ThemeName = 'iron_night' | 'crimson_forge' | 'slate_steel' | 'obsidian_white' | 'carbon_minimal';

export interface Theme {
  name: ThemeName;
  displayName: string;
  colors: {
    // Do not use hardcoded colors in screens; use these theme tokens.
    background: string;
    surface: string;
    surfaceVariant: string;
    primary: string;
    primaryVariant: string;
    secondary: string;
    text: string;
    textSecondary: string;
    textTertiary: string;
    border: string;
    borderLight: string;
    accent: string;
    accentForeground: string;
    accentLight: string;
    success: string;
    warning: string;
    error: string;
  };
}

export const THEMES: Record<ThemeName, Theme> = {
  iron_night: {
    name: 'iron_night',
    displayName: 'Iron Night',
    colors: {
      background: '#030303',
      surface: '#0A0A0A',
      surfaceVariant: '#111111',
      primary: '#B8972E',
      primaryVariant: '#D4AD3C',
      secondary: '#1A1A1A',
      text: '#E8E4DB',
      textSecondary: '#d1d5db',
      textTertiary: '#9ca3af',
      border: '#1A1A1A',
      borderLight: '#2A2A2A',
      accent: '#B8972E',
      accentForeground: '#030303',
      accentLight: '#D4AD3C',
      success: '#22c55e',
      warning: '#B8972E',
      error: '#C62828',
    },
  },
  crimson_forge: {
    name: 'crimson_forge',
    displayName: 'Crimson Forge',
    colors: {
      background: '#0f0506',
      surface: '#1a0a0c',
      surfaceVariant: '#2a1215',
      primary: '#dc2626',
      primaryVariant: '#b91c1c',
      secondary: '#7f1d1d',
      text: '#fef2f2',
      textSecondary: '#fca5a5',
      textTertiary: '#c27878',
      border: '#3b1117',
      borderLight: '#4c1d24',
      accent: '#dc2626',
      accentForeground: '#ffffff',
      accentLight: '#f87171',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
    },
  },
  slate_steel: {
    name: 'slate_steel',
    displayName: 'Slate Steel',
    colors: {
      background: '#111418',
      surface: '#1a1e24',
      surfaceVariant: '#252a32',
      primary: '#14b8a6',
      primaryVariant: '#0d9488',
      secondary: '#1e3a3a',
      text: '#e2e8f0',
      textSecondary: '#d1d5db',
      textTertiary: '#9ca3af',
      border: '#2d333b',
      borderLight: '#3d444d',
      accent: '#14b8a6',
      accentForeground: '#ffffff',
      accentLight: '#5eead4',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
    },
  },
  obsidian_white: {
    name: 'obsidian_white',
    displayName: 'Obsidian White',
    colors: {
      background: '#050505',
      surface: '#121212',
      surfaceVariant: '#1c1c1c',
      primary: '#f5f5f5',
      primaryVariant: '#d4d4d4',
      secondary: '#525252',
      text: '#fafafa',
      textSecondary: '#d1d5db',
      textTertiary: '#9ca3af',
      border: '#262626',
      borderLight: '#3a3a3a',
      accent: '#737373',
      accentForeground: '#0a0a0a',
      accentLight: '#a3a3a3',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
    },
  },
  carbon_minimal: {
    name: 'carbon_minimal',
    displayName: 'Carbon Minimal',
    colors: {
      background: '#000000',
      surface: '#0e0d08',
      surfaceVariant: '#1a1810',
      primary: '#f59e0b',
      primaryVariant: '#d97706',
      secondary: '#78350f',
      text: '#fef9ec',
      textSecondary: '#c9a855',
      textTertiary: '#a89050',
      border: '#27220e',
      borderLight: '#3b3418',
      accent: '#f59e0b',
      accentForeground: '#ffffff',
      accentLight: '#fbbf24',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
    },
  },
};

export const DEFAULT_THEME: ThemeName = 'iron_night';
